import { DateRange } from 'rsuite/esm/DateRangePicker';
import { LabelValueType } from '../../../components/AsyncFormSelect/AsyncFormSelect';
import { RiskSegment } from '../../../components/Tooltips/RiskSegment/RiskSegmentIndicator';
import type { BET_LIST_URL_OPTION_FIELDS } from '../constants/betListFilterConstants';

export enum BetTypesEnum {
  FreeBet = 0,
  Single = 1,
  Multiple = 2,
  System = 3,
  Folds = 4,
  Trixie = 5,
  Patent = 6,
  Yankee = 7,
  Lucky15 = 8,
  SuperYankee = 9,
  Lucky31 = 10,
  Heinz = 11,
  Lucky63 = 12,
  SuperHeinz = 13,
  Goliath = 14,
  FreeBetMultiple = 15,
  Other = 999
}

export enum BET_STATUS {
  ALL = 0,
  OPEN = 1,
  WON = 2,
  LOST = 3,
  RETURNED = 4,
  CASHED_OUT = 5,
  PARTIALY_CASHED_OUT = 6,
  EARLY_PAYOUT = 8,
  CANNOT_RECALCUATE = 9,
  RESULT_DIFFERENCE = 10,
}

export enum BET_LIST_LIVE_PREMATCH_EVENT_TYPES_ENUM {
  ALL = 1,
  PREMATCH = 2,
  INPLAY = 3
}

export const BET_LIST_PREMATCH_EVENT_TYPE: LabelValueType = {
  label: 'Prematch',
  value: BET_LIST_LIVE_PREMATCH_EVENT_TYPES_ENUM.PREMATCH.toString(),
};

export const BET_LIST_LIVE_EVENT_TYPE: LabelValueType = {
  label: 'Live',
  value: BET_LIST_LIVE_PREMATCH_EVENT_TYPES_ENUM.INPLAY.toString(),
};

export const BET_LIST_ALL_EVENT_TYPE: LabelValueType = {
  label: 'Both',
  value: BET_LIST_LIVE_PREMATCH_EVENT_TYPES_ENUM.ALL.toString(),
};

export const BET_LIST_FILTER_EVENT_TYPES: LabelValueType[] = [
  BET_LIST_PREMATCH_EVENT_TYPE,
  BET_LIST_LIVE_EVENT_TYPE,
  BET_LIST_ALL_EVENT_TYPE,
];

export enum YES_NO_VALUES {
  ALL = '1',
  YES = '2',
  NO = '3'
}

export const yesNoValues: LabelValueType[] = [
  {
    label: 'All',
    value: YES_NO_VALUES.ALL,
  },
  {
    label: 'Yes',
    value: YES_NO_VALUES.YES,
  },
  {
    label: 'No',
    value: YES_NO_VALUES.NO,
  },
];

export enum BET_LIST_FREE_BET_TYPES {
  ALL = '1',
  NO_FREE_BETS = '2',
  FREEBETS = '3',
  NO_RISK_FREEBETS = '4',
  BOTH = '5'
}

export const BET_LIST_FREE_BET_TYPES_ALL: LabelValueType = {
  label: 'All',
  value: BET_LIST_FREE_BET_TYPES.ALL,
};

export const BET_LIST_FREE_BET_TYPES_NO_FREE_BETS: LabelValueType = {
  label: 'Not Freebet',
  value: BET_LIST_FREE_BET_TYPES.NO_FREE_BETS,
};

export const BET_LIST_FREE_BET_TYPES_FREEBETS: LabelValueType = {
  label: 'Freebets',
  value: BET_LIST_FREE_BET_TYPES.FREEBETS,
};

export const BET_LIST_FREE_BET_TYPES_NO_RISK_FREEBETS: LabelValueType = {
  label: 'NoRiskBet',
  value: BET_LIST_FREE_BET_TYPES.NO_RISK_FREEBETS,
};

export const BET_LIST_FREE_BET_TYPES_BOTH: LabelValueType = {
  label: 'NoRiskBet + Freebet',
  value: BET_LIST_FREE_BET_TYPES.BOTH,
};

export const BET_LIST_FREE_BET_TYPES_OPTIONS: LabelValueType[] = [
  BET_LIST_FREE_BET_TYPES_ALL,
  BET_LIST_FREE_BET_TYPES_NO_FREE_BETS,
  BET_LIST_FREE_BET_TYPES_FREEBETS,
  BET_LIST_FREE_BET_TYPES_NO_RISK_FREEBETS,
  BET_LIST_FREE_BET_TYPES_BOTH,
];

export enum BET_LIST_IS_TEST_ENUM {
  ALL_BETS = '1',
  REAL_BETS = '2',
  TEST_BETS = '3',
}

export const BET_LIST_IS_TEST_ALL: LabelValueType = {
  label: 'All',
  value: BET_LIST_IS_TEST_ENUM.ALL_BETS,
};

export const BET_LIST_IS_TEST_REAL_BETS = {
  label: 'Real Bets',
  value: BET_LIST_IS_TEST_ENUM.REAL_BETS,
};

export const BET_LIST_IS_TEST_TEST_BETS = {
  label: 'Test Bets',
  value: BET_LIST_IS_TEST_ENUM.TEST_BETS,
};

export const BET_LIST_IS_TEST_VALUES: LabelValueType[] = [
  BET_LIST_IS_TEST_ALL,
  BET_LIST_IS_TEST_REAL_BETS,
  BET_LIST_IS_TEST_TEST_BETS,
];

export enum BET_LIST_BET_TYPES {
  ALL = '1',
  SINGLES = '2',
  MULTIBETS ='3',
  SYSTEM = '4',
  FOLDS_AND_OTHER = '5'
}

export const BET_LIST_BET_TYPES_ALL: LabelValueType = {
  label: 'All',
  value: BET_LIST_BET_TYPES.ALL,
};

export const BET_LIST_BET_TYPES_SINGLES: LabelValueType = {
  label: 'Singles',
  value: BET_LIST_BET_TYPES.SINGLES,
};

export const BET_LIST_BET_TYPES_MULTIBETS: LabelValueType = {
  label: 'Multibets',
  value: BET_LIST_BET_TYPES.MULTIBETS,
};

export const BET_LIST_BET_TYPES_SYSTEM: LabelValueType = {
  label: 'System',
  value: BET_LIST_BET_TYPES.SYSTEM,
};

export const BET_LIST_BET_TYPES_FOLDS_AND_OTHER: LabelValueType = {
  label: 'Folds and Other',
  value: BET_LIST_BET_TYPES.FOLDS_AND_OTHER,
};

export const BET_TYPES: LabelValueType[] = [
  BET_LIST_BET_TYPES_ALL,
  BET_LIST_BET_TYPES_SINGLES,
  BET_LIST_BET_TYPES_MULTIBETS,
  BET_LIST_BET_TYPES_SYSTEM,
  BET_LIST_BET_TYPES_FOLDS_AND_OTHER,
];

export interface BetListFilterModel {
    playerID?: number | string;
    playerLogin?: string;
    eventID?: number | string;
    status?: LabelValueType;
    sport?: LabelValueType;
    tournament?: LabelValueType;
    type?: LabelValueType | null;
    betBuilder?: LabelValueType;
    freebet?: LabelValueType;
    BetTypes?: LabelValueType[] | null;
    legs?: number;
    isTest?: LabelValueType;
    barcode?: string;
    betID?: string;
    betUuid?: string;
    skip?: number;
    take?: LabelValueType;
    currentPage?: number;
    sportsIds?: LabelValueType[];
    tournamentIds?: LabelValueType[];
    maxStakePercent?: number;
    isPartiallyCashedOut?: LabelValueType;
    feeds?: LabelValueType[];
    datePlaced?: DateRange | null;
    dateClosed?: DateRange | null;
    BetShopBonus?: LabelValueType;
    SuperChargedOddCampaign?: LabelValueType;
    RiskSegmentUuids?: LabelValueType[];
    FranchiseIds?: LabelValueType[];
    OrderColumnName?: string;
    OrderColumnDirection?: number;
    MinAmount?: string;
    IsFirstPlayerBet?: LabelValueType;
    MarketUnionIds?: LabelValueType[];
    OddBoosted?: LabelValueType;
    OddBoostId?: string;
    IpAddress?: string;
    IsBetRequest?: LabelValueType;
    OddId?: number;
    AdditionalValue?: number;
    PreBuildEventItemId?: number;
    SavedFilter?: LabelValueType | null;
}

export interface BetListSavedFilterDetail {
  name: string;
  value: string;
}

export interface BetListAvailableSavedFilter {
  values: Partial<BetListFilterModel>;
  hasDropped: boolean;
}

export type BetListFilterKey = keyof BetListFilterModel;

export type BetListUrlOptionField = typeof BET_LIST_URL_OPTION_FIELDS[number];

export type BetListUrlOptions = Partial<Record<BetListUrlOptionField, LabelValueType[]>>;

export type BetListSavedFilterOptions = BetListUrlOptions & { SuperChargedOddCampaign?: LabelValueType[] };

export interface BetListUrlOptionsState {
  isReady: boolean;
  options: BetListSavedFilterOptions;
}

export interface BetListRow {
  CompanyName: string;
  Company: number;
  Barcode: string;
  ExternalBetID: number;
  DateCreated: string;
  Amount: number;
  EventIds: number[];
  BetShopBonus: number;
  Currency: string;
  OddValue: number;
  AmountWon: number;
  PlayerID: number;
  FinalOddValue: number;
  Comment: string;
  CommentTypeID: number;
  BetStatusID: number;
  BetUUID: string;
  DateClosed: string;
  BetType: string;
  MatchName: string;
  StartDateTime: string;
  BetID: number;
  PlayerUuid: string;
  MaxStake: number;
  OddName: string;
  BetBuilderFilter: number;
  IsBetRequest: boolean;
  Login: string;
  TypeId: number;
  LegCount: number;
  BonusStake: number;
  BonusAmountWon: number;
  YakataAmount: number;
  SuperChargedOddAmount: number;
  SuperChargedOdd: number;
  OneGameCutAmount: number;
  IsFirstPlayerBet?: boolean;
  BetResult: string;
  FinalScore: string;
  Ip: string;
  Source: string;
  VoidReasonId: number | null;
  VoidReasonName: string | null;
  RiskSegments: RiskSegment[];
  SettlementStatus: number;
  ManagerCurrency: string;
  Sport: number;
  Tournament: number;
  TournamentName: string;
  MaxStakePercent: number;
  IsPartiallyCashedOut: boolean;
  IsCashedOut: boolean;
  FranchiseId: number;
  SuperChargedOddSettingUuid: string | null;
  IsTestBet: boolean;
  BetTypeId: number;
  FreeBetType: number | null;
  FeedId: number;
  CommentsCount: number;
  RecentCommentTypeId: number;
  RecentComment: string;
  MarketUnionIds?: number[];
  OddBoostId: number;
  OriginalOddValue: number;
}
export interface BetListTournamentType {
  Id: string;
  Name: string;
  SportId: string,
  CountryId: string,
  CountryName: string
}

export interface BetsTotalsType {
  Balance?: number;
  Margin?: number;
  MoneyPaid?: number;
  MoneyPlayed?: number;
  RecordCount?: number;
  Turnover?: number;
  TurnoverInPlay?: number;
}

export interface BetRequest {
    Id: number;
    PlayerId: number;
    BetId: number;
    BetUUID: number;
    FranchiseId: number;
    CompanyId: number;
    CompanyName: string;
    Amount: number;
    RequestTime: string;
    ReviewedAt: string;
    ReviewedBy?: string;
    Currency: string;
    OddValue: number;
    RequestState: number;
    EventId: number;
    IsEventLive: boolean;
    EventName: string;
    OddName: string;
    BetType: string;
    Postfix: string;
    RiskSegments: RiskSegment[];
    Uuid: string;
}

export interface BetRequestOddModel {
  CorrectScore: string;
  DateStart: string;
  IsEventStarted: boolean;
  IsLive: boolean;
  OddName: string;
  EventId: number;
  EventName: string;
  EventStartTime: string;
  OddValue: number;
  Postfix: string;
  Prefix: string;
  SportName: string;
  Team1Name: string;
  Team2Name: string;
  TeamPlayer1Name?: string;
  TeamPlayer2Name?: string;
  UniqueFranchise: number;
  VariationName?: string;
  CountryName?: string;
  TournamentName?: string;
  Max?: number;
  Risk?: number;
  MBL?: number;
  OddValueNow?: string;
  ProviderId: number;
}

export interface BetRequestDetails {
  Amount: number;
  BetType: string;
  Comment: string;
  CompanyName: string;
  Currency: string;
  FranchiseName: string;
  ID: number;
  Login: string;
  OddValue: number;
  Odds: BetRequestOddModel[];
  PlayerIP: string;
  PlayerID: number;
  PlayerUuid: string;
  PotentialWinnings: number;
  RequestState: number;
  RequestTime: string;
  TotalOdds: number;
  TotalStake: number;
  ReviewReason: string;
  RiskSegments: RiskSegment[];
  ReviewedAt: string;
  ReviewedBy: string;
  Source: string;
  Company: number;
  Barcode: string;
  OriginalOddValue?: number;
  YakataAmount?: number;
  FranchiseId: number;
}
export enum CASHED_OUT_VALUES {
  ALL = '0',
  NOT_CASH_OUT = '1',
  CASH_OUT = '2',
  PARTIALY_CASH_OUT = '3',
}

export const cashoutValues: LabelValueType[] = [
  {
    label: 'All',
    value: CASHED_OUT_VALUES.ALL,
  },
  {
    label: 'Not Cashed Out',
    value: CASHED_OUT_VALUES.NOT_CASH_OUT,
  },
  {
    label: 'Cashed Out',
    value: CASHED_OUT_VALUES.CASH_OUT,
  },
  {
    label: 'Partial Cash Out',
    value: CASHED_OUT_VALUES.PARTIALY_CASH_OUT,
  },
];

export enum FRMessageType {
  None = 0,
  NameMissMatchInBankTransaction = 1,
  SureBet = 2,
  MaxRequest = 3,
  ResultNotEntered = 4,
  NewOnlinePlayerRegistration = 5,
  RkioskServerDead = 6,
  RKioskError = 7,
  OddsFrozen = 8,
  DepositConfirmationRequired = 9,
  WithdrawalCancelationRequested = 10,
  BetRequest = 11,
  OddsUpdated = 12,
  ResultsUpdated = 13,
  NegativePlayerBalance = 14,
  CheckBet = 15,
  XReportData = 16,
  BettingShopWithdrawal = 17,
  BetResultChanged = 18,
  CalculationError = 19,
  MaxRequestLive = 20,
  LiveAndEnteredResultsDiffer = 21,
  LptService = 22,
  ExternalKycValidation = 23,
  ExternalValidator = 24,
  CheckBetLive = 26,
  DepositThresholds = 27,
  PlayerIsPolitician = 28,
  PlayerIsTrueBeneficiary = 29,
  PlayerFirstRealDeposit = 30,
  EventAutoCreateError = 31,
  ExternalKycDuplicatePlayerOldOneDisabled = 32,
  FreeroundsFailedToAssign = 33,
  BookLossLimitBoundary = 34,
  EventStartDateChanged = 35,
  IDenfyStatusChanges = 36,
  RollbackUnsuccessful = 37,
  CampaignExhaustedBalance = 38,
  VerificationCodeMessageNotSent = 39,
  PlayerLoginAllowedSelfExclusionCheckNotAvailable = 40,
  PlayerAccountNumberBICCodeNotFound = 41,
  DefaultPlayerWithdrawalRequestRejected = 42,
  IbanityWithdrawalRequestFailed = 43,
  FileHashesMismatch = 45,
  ReconciliationDepositStatus = 46,
  RejectedWithdrawalConfirmed = 47,
  SwedbankWithdrawalRejected = 48,
  BgcService = 49,
  PayseraWithdrawalRejected = 50,
  NuveiDepositChargeback = 51,
  ConnectionFailedBetRadar = 52,
  EmailSendFailed = 53,
  CodaFileImport = 54,
  Payment = 55,
  QuickPaidOutBet = 56,
  BigBet = 57,
  BookLossLimitIncreasedAuto = 58,
  OneWayOddsAdjustment = 60
}

export interface FranchiseNotification {
  Id: number;
  FranchiseId: number;
  Uuid: string;
  PlayerId: number;
  PlayerUuid: string;
  FranchiseName: string;
  EventId: number;
  EventName?: string;
  EventStartTimeUtc: Date;
  IsEventLive?: boolean;
  BetRequestId: number;
  OddUnionId: number;
  IsRead: boolean;
  ReadByManagerName: string;
  ReadDate: Date;
  MessageDate: Date;
  MessageText: string;
  MessageType: FRMessageType;
  MarketName: string;
  MaxBookLossValuePercentage: number;
  Risk: number;
  OddBookLossAmount: number;
  Currency: string;
  OddName: string;
  Amount: number;
  ExternalBetId: number;
  Origin: number;
  BetUuid: string;
  MessageReason: string;
  BookLossIncreaseAmount: number;
  RiskSegments: RiskSegment[];
  OddBoostId?: number;
}

export enum REQUEST_STATE {
  Pending = 0, Accepted = 1, Rejected = 2,
}

export enum BET_LIST_PAGE_SEARCH_PARAMS {
  SUPER_CHARGED_ODD_ID = 'scid',
  SUPER_CHARGED_ODD_NAME = 'scnm',
  SET_NO_DATE = 'ndt',
  EVENT_ID = 'eid',
  PLAYER_ID = 'pid',
  IS_REDIRECT = 'rd',
  BET_UUID = 'buid',
  BET_REQUEST_ID = 'brid',
  TYPE = 'type',
  BET_TYPE = 'betType',
  MARKET_UNION_ID = 'muid',
  BOOSTED_ODD_ID = 'boid',
  DATE_PLACED = 'dp',
  DATE_CLOSED = 'dc',
  FRANCHISE_IDS = 'fids',
  BARCODE = 'bc',
  EXTERNAL_BET_ID = 'bid',
  LEGS = 'lg',
  SPORT_IDS = 'sp',
  TOURNAMENT_IDS = 'tr',
  STATUS = 'st',
  BET_BUILDER = 'bb',
  FREEBET = 'fb',
  IS_TEST = 'it',
  CASHOUT = 'co',
  MAX_STAKE_PERCENT = 'msp',
  PROVIDERS = 'pr',
  BONUS = 'bn',
  RISK_SEGMENTS = 'rs',
  MIN_AMOUNT = 'ma',
  FIRST_BET = 'fpb',
  BET_REQUEST = 'ibr',
  PREBUILD_VIEW_ID = 'pbid',
  ODD_ID = 'oid',
  ADDITIONAL_VALUE = 'av',
}

export enum BET_LIST_BONUS_TYPES {
  ALL = '0',
  WITH_BONUS = '1',
  WITHOUT_BONUS = '2',
  WITH_ACCUMULATOR_BONUS = '3',
  WITHOUT_ACCUMULATOR_BONUS = '4',
  WITH_SUPERCHARGED_ODDS = '5',
  WITHOUT_SUPERCHARGED_ODDS = '6',
  WITH_1_GAME_CUT = '7',
  WITHOUT_1_GAME_CUT = '8',
  BETS_WITH_ODDBOOST = '9',
  BETS_WITHOUT_ODDBOOST = '10',
}
export enum FreeBetResponseType {
  Freebet = 0,
  NoRiskBet = 1
}
export const BET_SHOP_BONUS_ALL_BETS: LabelValueType = {
  label: 'All Bets',
  value: BET_LIST_BONUS_TYPES.ALL,
};

export const BET_SHOP_BONUS_WITH_BONUS: LabelValueType = {
  label: 'Bets With Bonus',
  value: BET_LIST_BONUS_TYPES.WITH_BONUS,
};

export const BET_SHOP_BONUS_WITHOUT_BONUS: LabelValueType = {
  label: 'Bets Without Bonus',
  value: BET_LIST_BONUS_TYPES.WITHOUT_BONUS,
};

export const BET_SHOP_BONUS_WITH_ACCUMULATOR_BONUS: LabelValueType = {
  label: 'Bets With Accumulator Bonus',
  value: BET_LIST_BONUS_TYPES.WITH_ACCUMULATOR_BONUS,
};

export const BET_SHOP_BONUS_WITHOUT_ACCUMULATOR_BONUS: LabelValueType = {
  label: 'Bets Without Accumulator Bonus',
  value: BET_LIST_BONUS_TYPES.WITHOUT_ACCUMULATOR_BONUS,
};

export const BET_SHOP_BONUS_WITH_SUPERCHARGED_ODDS: LabelValueType = {
  label: 'Bets With SuperchargedOdds',
  value: BET_LIST_BONUS_TYPES.WITH_SUPERCHARGED_ODDS,
};

export const BET_SHOP_BONUS_WITHOUT_SUPERCHARGED_ODDS: LabelValueType = {
  label: 'Bets Without SuperchargedOdds',
  value: BET_LIST_BONUS_TYPES.WITHOUT_SUPERCHARGED_ODDS,
};

export const BET_SHOP_BONUS_WITH_1_GAME_CUT: LabelValueType = {
  label: 'Bets With 1GameCut',
  value: BET_LIST_BONUS_TYPES.WITH_1_GAME_CUT,
};

export const BET_SHOP_BONUS_WITHOUT_1_GAME_CUT: LabelValueType = {
  label: 'Bets Without 1GameCut',
  value: BET_LIST_BONUS_TYPES.WITHOUT_1_GAME_CUT,
};

export const BETS_WITH_ODDBOOST: LabelValueType = {
  label: 'Bets with Boosted Odds',
  value: BET_LIST_BONUS_TYPES.BETS_WITH_ODDBOOST,
};

export const BETS_WITHOUT_ODDBOOST: LabelValueType = {
  label: 'Bets without Boosted Odds',
  value: BET_LIST_BONUS_TYPES.BETS_WITHOUT_ODDBOOST,
};

export const BET_LIST_BONUS_OPTIONS = [
  BET_SHOP_BONUS_ALL_BETS,
  BET_SHOP_BONUS_WITH_BONUS,
  BET_SHOP_BONUS_WITHOUT_BONUS,
  BET_SHOP_BONUS_WITH_ACCUMULATOR_BONUS,
  BET_SHOP_BONUS_WITHOUT_ACCUMULATOR_BONUS,
  BET_SHOP_BONUS_WITH_SUPERCHARGED_ODDS,
  BET_SHOP_BONUS_WITHOUT_SUPERCHARGED_ODDS,
  BET_SHOP_BONUS_WITH_1_GAME_CUT,
  BET_SHOP_BONUS_WITHOUT_1_GAME_CUT,
  BETS_WITH_ODDBOOST,
  BETS_WITHOUT_ODDBOOST,
];

export enum NoRiskSegment {
  NoSegment = '0',
}

export const NO_RISK_SEGMENT_OPTION = [
  { label: 'No segment', value: NoRiskSegment.NoSegment },
];

export enum IS_FIRST_PLAYER_BET_ENUM {
  ALL = '1',
  ONLY_FIRST = '2',
  NOT_FIRST = '3',
}

export const IS_FIRST_PLAYER_BET_OPTION: LabelValueType[] = [
  {
    label: 'All',
    value: IS_FIRST_PLAYER_BET_ENUM.ALL,
  },
  {
    label: 'Yes',
    value: IS_FIRST_PLAYER_BET_ENUM.ONLY_FIRST,
  },
  {
    label: 'No',
    value: IS_FIRST_PLAYER_BET_ENUM.NOT_FIRST,
  },
];

export enum BETBUILDER_OPTIONS {
  ALL = '0',
  NOT_BET_BUILDER = '1',
  BET_BUILDER = '2',
  BET_BUILDER_RECALC = '3',
  BET_BUILDER_NOT_RECALC = '4',
  PREBUILDS = '5',
  NOT_PREBUILDS = '6',
}

export const BetbuilderOptions: LabelValueType[] = [
  { label: 'All', value: BETBUILDER_OPTIONS.ALL },
  { label: 'Not BetBuilder', value: BETBUILDER_OPTIONS.NOT_BET_BUILDER },
  { label: 'BetBuilder', value: BETBUILDER_OPTIONS.BET_BUILDER },
  { label: 'BetBuilder Recalc', value: BETBUILDER_OPTIONS.BET_BUILDER_RECALC },
  { label: 'BetBuilder Not Recalc', value: BETBUILDER_OPTIONS.BET_BUILDER_NOT_RECALC },
  { label: 'Prebuilds', value: BETBUILDER_OPTIONS.PREBUILDS },
  { label: 'Not Prebuilds', value: BETBUILDER_OPTIONS.NOT_PREBUILDS },
];
